/*global $:false */

import AdvancedSearchM from "./recordm.model.advancedsearch.js";
import RecordmImporterStatsM from "./recordm.importer.model.stats.js";

const ImporterStatsAdvancedSearchM = function(core, searchUrl, downloadAllUrl, downloadSelectedUrl) {
    AdvancedSearchM.apply(this, [core, searchUrl, downloadAllUrl, downloadSelectedUrl]);

    this._searchFilters = [];
    this._statsM = new RecordmImporterStatsM(core);
};

ImporterStatsAdvancedSearchM.prototype = new AdvancedSearchM();
ImporterStatsAdvancedSearchM.prototype.constructor = ImporterStatsAdvancedSearchM;
ImporterStatsAdvancedSearchM.prototype._name = 'ImporterStatsAdvancedSearchM';
ImporterStatsAdvancedSearchM.prototype._name = 'ImporterStatsAdvancedSearchM';

ImporterStatsAdvancedSearchM.prototype.filterSummaryStats = function() {
    this._searchFilters = [{
        field: "type",
        value: "summary",
        operator: AdvancedSearchM.queryOperators.EXACT_MATCH
    }];
};

ImporterStatsAdvancedSearchM.prototype.filterLineStatsFor = function(importId) {
    this._searchFilters = [
        {
            field: "type",
            value: "line",
            operator: AdvancedSearchM.queryOperators.EXACT_MATCH
        },
        {
            field: "import_id",
            value: importId,
            operator: AdvancedSearchM.queryOperators.EXACT_MATCH
        }
    ];
};

ImporterStatsAdvancedSearchM.prototype.getSearchResults = function() {
    return this._statsM;
};

ImporterStatsAdvancedSearchM.prototype._clearSearchResults = function() {
    this._totalMatchingInstances = 0;
    this._statsM.clear();
};

/*
 * Private method that executes a search
 * opts:
 * *`refresh`: parameter indicates whether it's a refresh search action or not
 * *`onSearchDone`: the callback to invoke after the search is done
 * *`eventId`: (OPTIONAL) the search request identifier in order to be able to perform
 * multiple searches in different modules at the same time
 */
ImporterStatsAdvancedSearchM.prototype._executeSearch = function(opts) {
    const _this = this,
        _opts = opts || {},
        from = _opts.refresh ? 0 : this._from,
        eventId = opts && opts.eventId ? opts.eventId : "";

    const numStats = this._statsM.getNumStats();

    if (_opts.refresh && numStats > this._rowsPerPage) {
        this._rowsPerPage = numStats;
    }

    $.ajax({
        url: this._buildSearchUrl(from, this._rowsPerPage, this._sortField, this._sortAsc),
        type: 'POST',
        contentType: 'application/json',
        data: ImporterStatsAdvancedSearchM._buildSearchQuery(this._query, this._searchFilters),
        success: function(data) {

            if (_opts.refresh) {
                _this._clearSearchResults();
            }

            _this._statsM.addStats(data.hits);

            // update the total records matching
            _this._totalMatchingInstances = _this._statsM.getNumStats();
        },
        error: function(req) {
            window.console.log("SEARCH:ERROR: " + req.status + " : " + req.statusText + ":" + req.responseText);
            _this._core.publish('recordm:search:error' + eventId, {errorCode: req.status});
        },
        complete: function() {
            _this._core.publish('recordm:search:finished' + eventId, {advancedSearch: true, stats: _this._statsM});
        }
    });
};

//Private helper that builds a search string
ImporterStatsAdvancedSearchM.prototype._buildSearchUrl = function(from, rowsToFetch, sortField, sortAsc) {
    var endpointUrl = this.searchurl +
                      '?from=' + (from) +
                      '&size=' + (rowsToFetch);

    if (sortField) {
        endpointUrl += "&sort=" + sortField +
                       "&ascending=" + sortAsc;
    }

    return endpointUrl;
};

//Private helper that builds a search request body
ImporterStatsAdvancedSearchM._buildSearchQuery = function(searchParameters, searchFilters) {
    var searchQuery = { "query": { "bool": {} } };

    searchQuery.query.bool.must_not = searchParameters.filter(function(parameter) {
        return parameter.operator.substring(0, 4) === 'NOT_';
    }).map(ImporterStatsAdvancedSearchM._parseSearchParameter);

    searchQuery.query.bool.must = searchParameters.filter((parameter) => parameter.operator.substring(0, 4) !== 'NOT_')
        .map(ImporterStatsAdvancedSearchM._parseSearchParameter)
        .concat(searchFilters.map(ImporterStatsAdvancedSearchM._parseSearchParameter));

    return JSON.stringify(searchQuery);
};

ImporterStatsAdvancedSearchM._parseSearchParameter = function(parameter) {
    var ops = AdvancedSearchM.queryOperators,
        paramValue = parameter.value;

    if(paramValue === undefined || paramValue === null || paramValue === ''
       || ![ops.EXACT_MATCH, ops.NOT_EXACT_MATCH].includes(parameter.operator)){
        return AdvancedSearchM._parseSearchParameter(parameter);
    }

    //We only treat this case here because we do not want to use the fields ".raw" value
    return AdvancedSearchM._buildExactQueryPart(
        parameter.field,
        parameter.value,
        parameter.operator
    );
};

export default ImporterStatsAdvancedSearchM;
